import React, { useState, useEffect } from "react";

import moment from "moment";
import Chart from "./Chart";

const processData = (data, timeInterval) => {
  //console.log('data: %o, timeInterval: %o', data, timeInterval);
  if (!data || data.length < 1) {
    return [];
  }
  let r = [];
  let lastReading = data[0];
  r.push(lastReading);
  let timeDiff = 0;

  data.forEach((item) => {
    timeDiff = moment(lastReading.date).diff(moment(item.date), "minutes");
    //console.log('timeDiff: %o', timeDiff);
    if (Math.abs(timeDiff) > timeInterval && lastReading.id !== item.id) {
      lastReading = item;
      r.push(lastReading);
    }
  });
  if (lastReading.id !== data[data.length - 1].id) {
    r.push(data[data.length - 1]);
  }
  return r;
};

function LastReadingsChart({ seriesLabel, title, yaxis, data, stroke, timeInterval = 15, height = 350 }) {
  const [filteredData, setFilteredData] = useState();
  const [series, setSeries] = useState([]);

  useEffect(() => {
    if (!filteredData && data) {
      setFilteredData(processData(data, timeInterval));
    }
    // eslint-disable-next-line
  }, [data]);

  useEffect(() => {
    if (filteredData) {
      console.log("filteredData: %o", filteredData);
      setSeries([
        {
          name: seriesLabel,
          data: filteredData.map((item) => {
            return {
              x: moment(item.date).utc(true).toDate().getTime(),
              y: item.value,
            };
          }),
        },
      ]);
    }
    // eslint-disable-next-line
  }, [filteredData]);

  const options = {
    tooltip: {
      x: {
        show: true,
        format: "HH:mm",
      },
    },
    title: {
      text: title,
      align: "left",
    },
    stroke: {
      width: 2,
      curve: "smooth",
      ...stroke,
    },
    xaxis: {
      type: "datetime",
      title: {
        text: "Time",
      },
      min: new Date().getTime() - 1 * 24 * 60 * 60 * 1000,
      max: new Date().getTime(),
    },
    yaxis: yaxis,
  };

  return <Chart options={options} series={series} type="line" height={height} />;
}

export default LastReadingsChart;
